module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ToAudit"
  }, [_c('meta', {
    attrs: {
      "name": "description",
      "content": "以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    }
  }), _vm._v(" "), _c('title', [_vm._v("支付成功-以诺教育")]), _vm._v(" "), _c('headTop'), _vm._v(" "), _c('div', {
    staticClass: "audit"
  }, [_c('div', {
    staticClass: "handle"
  }, [_c('div', {
    staticClass: "handleL"
  }), _vm._v(" "), _c('div', {
    staticClass: "handleR"
  }, [_c('p', {
    staticClass: "we"
  }, [_vm._v("支付成功！")]), _vm._v(" "), _c('p', {
    staticClass: "titlePay"
  }, [_vm._v("您已成功支付“" + _vm._s(_vm.name) + "”报名款")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/orderList"
    }
  }, [_vm._v("查看订单>>")])], 1)])])]), _vm._v(" "), _c('Bottom')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70c94c2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentOrder/PaySuccess.vue
// module id = 553
// module chunks = 1